import {
  ApiCreateUpdateComponentPayload,
  ApiSimpleComponent,
  ApiComponentType,
  ApiComponentBlock,
} from "@incendium/api";
import { personalisationService } from "Apis";
import { LightningLanderThemeSettings } from "features/lightningLanders/types";

export const saveComponent = async (
  projectId: number,
  component: ApiSimpleComponent,
  token?: string
) => {
  const payload: ApiCreateUpdateComponentPayload = {
    ...component,
  };

  const fn = component?.id
    ? personalisationService.personalisationServiceUpdateComponent({
      projectId,
      componentId: component.id,
      payload,
      token,
    })
    : personalisationService.personalisationServiceCreateComponent({
      projectId,
      payload,
      token,
    });

  const res = await fn;
  return res;
};

export const readComponent = async (projectId, componentId) => {
  const res = await personalisationService.personalisationServiceReadComponent({
    projectId,
    componentId,
  });
  return res;
};

export const deleteComponent = async (projectId, componentId, token?) => {
  const res =
    await personalisationService.personalisationServiceDeleteComponent({
      projectId,
      componentId,
      token,
    });
  return res;
};

export const patchComponentTheme = async (
  projectId: number,
  componentId: number,
  theme: LightningLanderThemeSettings,
  token?: string
) => {
  const res =
    await personalisationService.personalisationServicePatchComponentTheme({
      projectId,
      componentId,
      body: {
        theme: JSON.stringify(theme),
        token,
      },
    });
  return res;
};

export const generateComponent = async (projectId: number, name: string, prompt: string, type: ApiComponentType, url?: string, componentId?: number, adId?: number, advanced?: boolean) => {
  const res = await personalisationService.personalisationServiceGenerateComponent({
    projectId,
    body: {
      name,
      prompt,
      url,
      type,
      componentId,
      adId,
      advanced,
    },
  });
  return res;
};

export const AIBlockEditor = async (projectId: number, prompt: string, block: ApiComponentBlock) => {
  const res = await personalisationService.personalisationServiceComponentAIBlockEditor({
    projectId,
    payload: {
      prompt,
      block,
    },
  });
  return res;
};

export const batchGenerateComponentsFromAds = async (
  projectId: number,
  adIds: number[],
  templateId: number,
  copyOnly: boolean = false
) => {
  const res = await personalisationService.personalisationServiceBatchGenerateComponentsFromAds({
    projectId,
    body: {
      adIds,
      templateId,
      copyOnly,
    },
  });
  return res;
};

